<template>
  <div class="cell b2b-card product-card product-card--has-header" qaid="plpProductCardItem">
    <div class="b2b-card__header product-card__header">
      <product-label-year
        :product="product"
        :product-url-customizer-open="productUrlCustomizerOpen"
        :base-properties="baseProperties"
        :qaid="`productCard${itemId}`"
      />

      <product-compare-button
        v-if="isCompareButtonVisible"
        small
        :product="product"
        :base-properties="baseProperties"
      />
    </div>
    <div class="relative">
      <pdl-link v-if="isCustomizeVisible" standalone href="product.projectOneUrl" class="absolute top-0 left-0"
        >{{ bp('customize') }}
      </pdl-link>
      <a :href="productUrl">
        <img class="b2b-card__img lazyload" :src="currentImageUrl" :alt="product.displayName" />
      </a>
    </div>
    <div class="b2b-card__body text-center">
      <div v-show="shouldDisplaySwatches" class="product-card__swatches mb-1" qaid="productCardSwatches">
        <pdl-swatch-group
          class="justify-center my-2"
          :options="swatches"
          :radio-name="`swatches-${product.code}`"
          :initial-selected-option="swatches[0]"
          @color-changed="changeImage"
        />
      </div>
      <h3 class="b2b-card__title mb-1 font-medium" qaid="productCardProductName">
        <a :href="productUrl">{{ product.displayName }}</a>
      </h3>
      <p class="product-card__price text-sm mt-0 mb-0" qaid="productCardPrice">
        <a :href="productUrl" class="no-underline">
          <span class="product-card__price--sale">{{ price.sale }}</span>
          <span v-if="price.adv" class="product-card__price--adv">{{ price.adv }}</span>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import productCard from './mixins/product-card';
import {mapState} from 'vuex';
import {PdlLink} from '@pedal/pdl-link';

export default {
  name: 'ProductCardItem',
  components: {
    PdlLink,
  },
  mixins: [productCard],
  computed: {
    ...mapState('plp', ['isColorSwatchAllowed']),
    shouldDisplaySwatches() {
      return this.swatches.length > 0 && this.isColorSwatchAllowed;
    },
  },
};
</script>

<style lang="scss" scoped>
.pdl-swatches {
  .product-card__swatches & {
    max-width: none;
  }
}
</style>
